import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import SettingsCentralMappingMenuBreakdownCard from 'lumen/components/settings/central-mapping/menu/breakdown-card';
import SettingsCentralMappingModalsModalMappingPermissions from 'lumen/components/settings/central-mapping/modals/modal-mapping-permissions';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type MarketSettingsCentralMappingMenuController from 'lumen/controllers/market/settings/central-mapping/menu';

interface MarketSettingsCentralMappingMenuSignature {
  Args: {
    controller: MarketSettingsCentralMappingMenuController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.central_mapping.subheader"}}
    @title={{t "settings.central-mapping.mapping"}}
    class="central-mapping"
  >
    <:link>
      <GeneralNavigationIntercomHelpLink
        @articleLink={{@controller.menuHelpCenterLink}}
        @iconName="link-out"
        @linkText={{t "general.learn_more"}}
        @type="text-and-icon"
      />
    </:link>
    <:headerAfter>
      {{#if @controller.canEditPermissions}}
        <PrismButton
          @buttonType="secondary"
          @label={{t "settings.central_mapping.permissions.edit_permissions"}}
          @onClick={{@controller.openPermissionsModal}}
          data-test-id="central-mapping-edit-permissions-button"
        />
      {{/if}}
    </:headerAfter>
    <:default>
      <div
        class="central-mapping__menu"
        data-test-id="central-mapping-portfolio-menu"
      >
        {{#each @controller.centralMapping.sortedBreakdowns as |breakdown|}}
          <SettingsCentralMappingMenuBreakdownCard
            @breakdown={{breakdown}}
            @hierarchyRoute={{@controller.hierarchyRoute}}
            @mappingRoute={{@controller.mappingRoute}}
          />
        {{/each}}
      </div>

      {{#if @controller.isShowingPermissionsModal}}
        <SettingsCentralMappingModalsModalMappingPermissions
          @initialPermission={{@controller.permissionAtOpen}}
          @isLoading={{@controller.saveMappingPermissionTask.isRunning}}
          @onChangePermission={{@controller.onChangePermission}}
          @onClose={{@controller.closePermissionsModal}}
          @onSave={{@controller.onSavePermission}}
          @selectedPermission={{@controller.selectedPermission}}
        />
      {{/if}}
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<MarketSettingsCentralMappingMenuSignature>;
